import React from 'react';
import { Button } from "@/components/ui/button";

export const Navbar = () => (
  <nav className="fixed top-0 w-full z-50 bg-[var(--bg-page)]/80 backdrop-blur-md border-b border-[var(--border-medium)]">
    <div className="container mx-auto px-6 h-20 flex items-center justify-between">
      <div className="font-bold text-xl uppercase tracking-wider text-[var(--text-primary)]">
        Digital Leader Project
      </div>
      <div className="hidden md:flex items-center gap-8">
        <a href="#services" className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors uppercase text-sm font-medium tracking-widest" data-testid="nav-services-link">Services</a>
        <a href="#about" className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors uppercase text-sm font-medium tracking-widest" data-testid="nav-about-link">About</a>
        <a href="#contact" className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors uppercase text-sm font-medium tracking-widest" data-testid="nav-contact-link">Contact</a>
        <a href="mailto:digitalleaderproject@gmail.com?subject=Free%20Website%20Audit%20Request" className="btn-primary text-sm px-6 py-2 min-h-[40px]" data-testid="nav-audit-cta">
          Get a free website audit
        </a>
      </div>
      <Button variant="outline" className="md:hidden border-[var(--brand-primary)] text-[var(--brand-primary)]" data-testid="nav-menu-button">
        Menu
      </Button>
    </div>
  </nav>
);
